export const REGISTER_FAIL = "REGISTER_FAIL";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const SUCCESS_MESSAGE_CLEAR = "SUCCESS_MESSAGE_CLEAR";
export const ERROR_CLEAR = "ERROR_CLEAR";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
